export const status = {
    Fail: { code: -1, Description: "Operation fail" },
    Undefined: { code: 0, Description: "Operation Undefined" },
    Success: { code: 1, Description: "operation successful" },
    ServerFail: { code: 504, Description: 'Server is not responding please contact the system administrators' },
    ServerTimeout: { code: 524, Description: 'The load was not loaded correctly.' },
    Pending: {code: 202, Description: "Operation in process"}
}

